export enum PasswordInvalidReason {
  CapitalLetterRequired = 'capital',
  NumberRequired = 'number',
  SpecialCharRequired = 'specialChar',
  MinimumLength = 'minimumLength',
}

export interface PasswordCheckResult {
  valid: boolean;
  reasons: PasswordInvalidReason[];
}
